export const questionsList = ['Opción múltiple: solo una respuesta',
                              'Opción múltiple: se permiten varias respuestas',
                              'Cuadro de texto con varias líneas',
                              'Cuadro de texto de una línea',
                              'Valor numérico',
                              'Fecha',
                              'Fecha y hora',
                              'Matriz'];